import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { obtenerGruposClaveViajeAuthAction } from "../../../ducks/aereosAuthDuck"
import TGrupoAereoAuth from "../TGrupoAereoAuth"
const VGrupoAereoAuth = () => {
    const { idGrupo } = useParams()
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerGruposClaveViajeAuthAction({ IdPagoGrupal: idGrupo }))
    }, [dispatch, idGrupo])
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Aereos Autorizados</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupoAereoAuth />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VGrupoAereoAuth